export enum LabelType {
  COLLECTION = "collection",
  KLYDO = "klydo",
}

export interface Label {
  id: string;
  type: LabelType;
  text: string;
  createdAt: Date;
  updatedAt: Date;
}
